// Chamadas às rotas do painel interno (api/admin.ts, api/admin-usuarios.ts, api/metricas.ts).
// O cookie da sessão (HttpOnly) vai sozinho: a página nunca o vê.

export interface UsuarioLogado {
  nome: string;
  email: string;
  admin: boolean;
}

export const chamarAdmin = async (rota: string, corpo: unknown) => {
  const resposta = await fetch(rota, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify(corpo),
  });
  const json = await resposta.json().catch(() => ({}));
  return { ok: resposta.ok, status: resposta.status, json };
};

// Mensagens genéricas de propósito: não dizem o que falta configurar nem se um e-mail existe
// (o detalhe fica no log do servidor).
const MENSAGENS: Record<string, string> = {
  credenciais: "E-mail ou senha incorretos.",
  limite: "Muitas tentativas. Aguarde alguns minutos e tente de novo.",
  indisponivel: "O painel está indisponível no momento.",
  senha_curta: "A senha precisa ter pelo menos 12 caracteres.",
  senha_atual: "A senha atual está incorreta.",
  senha_igual: "A nova senha precisa ser diferente da atual.",
  convite: "Este link é inválido, já foi usado ou venceu. Peça um novo a um administrador.",
  existe: "Já existe um usuário com esse e-mail.",
  proprio: "Você não pode fazer isso com o seu próprio usuário.",
  inativo: "Esse usuário está desativado. Reative antes de gerar um link.",
  admin: "Só administradores podem ver isso.",
  entrada: "Confira os campos e tente de novo.",
};

export const mensagemDeErro = (codigo: unknown, padrao = "Não foi possível concluir. Tente de novo em instantes.") =>
  (typeof codigo === "string" && MENSAGENS[codigo]) || padrao;
